import { QueriedRoles } from "@lib/core/services/user-services.graphql";
import { OperationType } from "@graphql-generated/graphql";

export const canRoleAccess = (
    userRoles: QueriedRoles,
    action: "CREATE" | "UPDATE" | "READ" | "DELETE",
    objectName: string,
) => {
    return userRoles.some((role) => {
        if (!Object.keys(role.permissions).includes(objectName)) {
            return false;
        }
        const permission = role.permissions[objectName];
        return Object.entries(permission.profileOperations).some(([key, data]) => key !== "GROUP" && data.values.includes(action));
    });
};

export const getRightsOnObject = (userRoles: QueriedRoles, objectName: string): Array<OperationType> => {
    const operationsSet = userRoles.reduce((allowedOperations, role) => {
        if (!Object.keys(role.permissions).includes(objectName)) {
            return allowedOperations;
        }
        const permission = role.permissions[objectName];
        const allowed = Object.entries(permission.profileOperations)
            .map(([_, operation]) => operation.values)
            .flat();
        return new Set([...allowedOperations, ...allowed]);
    }, new Set<OperationType>());
    return [...operationsSet];
};

export const hasRightsOnObject = (userRoles: QueriedRoles, objectName: string): boolean => {
    return userRoles.some((role) => {
        if (!Object.keys(role.permissions).includes(objectName)) {
            return false;
        }
        const permission = role.permissions[objectName];
        return Object.entries(permission.profileOperations)
            .map(([_, operation]) => operation.values)
            .flat()
            .includes("READ");
    });
};
